export default value => new Intl.NumberFormat('ru-RU').format(value).replace(',', '.');
